import { jwtDecode } from "jwt-decode";
import { constants } from "./globals";

export function parentDirectory(dir) {
  const lastSlash = dir.lastIndexOf("/");
  if (lastSlash === -1) {
    return dir;
  }
  if (lastSlash === 0) {
    return "/";
  }
  return dir.substring(0, lastSlash);
}

export function capitalizeWords(string_) {
  if (typeof string_ !== "string") return "";

  let result = string_
    .replaceAll(/_([A-Za-z])/g, (_, letter) => " " + letter.toUpperCase())
    .replaceAll(/([a-z])([A-Z])/g, "$1 $2")
    .replaceAll(/\s+/g, " ")
    .trim();

  // Делаем первую букву каждого слова заглавной
  return result
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export async function isOnline() {
  // Сначала проверим navigator.onLine — это быстрая клиентская проверка
  if (!navigator.onLine) {
    return false;
  }

  // Затем попробуем сделать реальный запрос к серверу (например, к Google DNS)
  try {
    const response = await fetch("https://www.5systems.ru/", {
      cache: "no-cache",
      method: "HEAD",
      mode: "no-cors", // позволяет делать запрос без CORS
      timeout: 5000, // таймаут можно задать через AbortController при необходимости
    });
    // Даже если статус не 200 — сам факт ответа означает, что есть связь
    return true;
  } catch {
    return false;
  }
}

export const isValidToken = (accessToken) => {
  if (!accessToken || isObjectEmpty(accessToken)) {
    return false;
  }
  const decoded = jwtDecode(accessToken);
  const currentTime = Date.now() / 1000;

  return decoded.exp > currentTime;
};

export function getFirstInArray(arr) {
  if (!Array.isArray(arr)) return undefined;
  return arr[0];
}

export function logGQLError(queryName, e) {
  try {
    let text =
      getFirstInArray(e?.networkError?.result?.errors)?.message || e.message;

    sessionStorage.setItem(
      "error_" + new Date(Date.now()).toISOString(),
      queryName + ": " + text,
    );

    consoleBeauty(queryName + ": " + text, "GraphQL", "red");
  } catch (error) {}
}

export function consoleBeauty(
  text,
  badgeText = "",
  bgColor = "#95B46A",
  color = "white",
) {
  console.log(
    `%c ${badgeText} `,
    `color: ${color}; background-color: ${bgColor}`,
    text,
  );
}

export const addValTo2DArray = (obj, val, curState) => {
  return { ...obj, [curState]: [...obj[curState], ...val] };
};

export const changeValIn1DArray = (obj, val, curState) => {
  let arr = [];
  Object.assign(arr, obj);
  if (!isIdentical(arr[curState], val)) arr[curState] = val;
  return arr;
};

export const getUA = () => {
  let device = "Unknown";
  const ua = {
    Android: /Android/i,
    BlackBerry: /BlackBerry/i,
    Bluebird: /EF500/i,
    "Chrome OS": /CrOS/i,
    Datalogic: /DL-AXIS/i,
    "Generic Linux": /Linux/i,
    Honeywell: /CT50/i,
    Windows: /IEMobile|Windows/i,
    Zebra: /TC70|TC55/i,
    iPad: /iPad/i,
    iPhone: /iPhone/i,
    iPod: /iPod/i,
    macOS: /Macintosh/i,
  };
  Object.keys(ua).map((v) => navigator.userAgent.match(ua[v]) && (device = v));
  return device;
};

// export const isObjectEmpty = (objectName) => {
//   if (
//     JSON.stringify(objectName) === "{}" ||
//     objectName === undefined ||
//     objectName === null
//   ) {
//     return true;
//   } else return false;
// };

export const isObjectEmpty = (objectName) => {
  if (objectName === null) return true;
  if (objectName === null) return true;
  if (objectName === undefined) return true;
  if (objectName === "undefined") return true;
  if (objectName === "00000000-0000-0000-0000-000000000000") return true;
  if (
    objectName?.$$typeof?.toString() === "Symbol(react.transitional.element)" ||
    objectName?.$$typeof?.toString() === "Symbol(react.element)"
  )
    return false;
  if (
    objectName instanceof Array &&
    objectName.length === 0 &&
    Object.keys(objectName).length === 0
  )
    return true;
  try {
    if (saveStringify(objectName) === "{}") return true;
    if (saveStringify(objectName) === '""') return true;
    if (saveStringify(objectName) === "") return true;
  } catch (error) {}

  if (typeof objectName === "number" && objectName === 0) return true;
  if (
    Object.prototype.toString.call(objectName) === "[object Date]" &&
    objectName.getFullYear() === 1
  )
    return true;
  else return false;
};

export const saveStringify = (obj) => {
  try {
    let res = JSON.stringify(obj);
    return res;
  } catch (error) {
    consoleBeauty(
      "Не удалось привести к строке объект\n",
      "saveStringify",
      "red",
    );
    return "";
  }
};

export function setLocalStorageItem(paramName, paramValue) {
  try {
    if (localStorage.getItem(paramName) === saveStringify(paramValue)) return;
    localStorage.setItem(paramName, saveStringify(paramValue));
  } catch (error) {}
}

export function getLocalStorageItem(paramName) {
  try {
    return saveParseJson(localStorage.getItem(paramName));
  } catch (error) {
    return "";
  }
}

export function setSessionStorageItem(paramName, paramValue) {
  try {
    if (sessionStorage.getItem(paramName) === saveStringify(paramValue)) return;
    sessionStorage.setItem(paramName, saveStringify(paramValue));
  } catch (error) {}
}

export function getSessionStorageItem(paramName) {
  try {
    return saveParseJson(sessionStorage.getItem(paramName));
  } catch (error) {
    return "";
  }
}

export function saveParseJson(val) {
  if (val === "") return "";
  try {
    return JSON.parse(val);
  } catch (error) {
    consoleBeauty("Не удалось распарсить строку", "saveStringify", "red");
    return undefined;
  }
}

export function getLocalToken() {
  // let oidc = saveParseJson(
  //   localStorage.getItem(
  //     "oidc.user:https://login.5systems.ru/realms/5systems/:webapp"
  //   )
  // );
  // return oidc?.access_token;
  return saveParseJson(localStorage.getItem("token") || `""`)?.replace('"', "");
}

export const joinParams = (stateValue, newParamValue, defType) => {
  let newValue = undefined;
  if (!stateValue) {
    newValue = defType;
    stateValue = defType;
  }
  if (Object.prototype.toString.call(stateValue) === "[object Array]") {
    let stringifiedObj = saveStringify(newParamValue);

    if (newParamValue?.id || newParamValue?.uuid) {
      let idSearch = newParamValue?.id || newParamValue?.uuid;
      let find = stateValue.find(
        (el) => el?.id === idSearch || el?.uuid === idSearch,
      );
      if (find) {
        stateValue = stateValue?.filter((f) => {
          return (
            (f?.id !== undefined ? f?.id !== find?.id : true) &&
            (f?.uuid !== undefined ? f?.uuid !== find?.uuid : true)
          );
        });
      }
      newValue = [...stateValue, newParamValue];
    }

    if (!stateValue.some((item) => saveStringify(item) === stringifiedObj)) {
      newValue = [...stateValue, newParamValue];
    } else {
      newValue = stateValue;
    }
  }
  if (Object.prototype.toString.call(stateValue) === "[object Object]") {
    newValue = {
      ...stateValue,
      ...newParamValue,
    };
  }
  return newValue;
};

export const isPlateCorrect = (str) => {
  if (!str) return false;
  let regex = /^\S{1}\d{3}\S{2}\d{2,3}$/gm;
  let arr = regex.exec(str);
  if (arr) return true;
  return false;
};

export const isIdentical = (arr1, arr2) => {
  if (isObjectEmpty(arr1) && isObjectEmpty(arr2)) return true;
  if (Array.isArray(arr1) && isObjectEmpty(arr2))
    if (
      saveStringify(arr1) === saveStringify([]) ||
      saveStringify(arr1) === saveStringify({})
    )
      return true;
    else return false;
  if (Array.isArray(arr2) && isObjectEmpty(arr1))
    if (
      saveStringify(arr2) === saveStringify([]) ||
      saveStringify(arr2) === saveStringify({})
    )
      return true;
    else return false;
  return saveStringify(arr1) === saveStringify(arr2);
};

export const createId = () =>
  (
    Math.floor(Math.random() * (99999999999 - 10000000000 + 1)) + 10000000000
  ).toString();

export const assignedArray = (array) => {
  return Object.assign([], array);
};

export const translateUrgency = (val) => {
  if (val === 2) return "Срочная рекомендация";
  else return "Выполнить по возможности";
};

export function roundMinutes(date) {
  try {
    return date.getMinutes() >= 45
      ? date.setHours(date.getHours() + 1) && date.setMinutes(0)
      : date.getMinutes() >= 30
        ? date.setMinutes(45)
        : date.getMinutes() >= 15
          ? date.setMinutes(30)
          : date.setMinutes(15);
  } catch {
    return undefined;
  }
}

function isDateValid(dateStr) {
  return !isNaN(new Date(dateStr));
}

export function parseRFC3339(dString) {
  if (!isDateValid(dString)) return;
  if (isObjectEmpty(new Date(dString))) return;
  return new Date(dString);
}

export function getOrderDate(item) {
  if (isObjectEmpty(item)) return "";
  if (!isObjectEmpty(item?.general_params?.date))
    return " от " + dateToString(parseRFC3339(item?.general_params?.date));

  return "";
}

export function dateToString(
  date,
  withHours = false,
  onlyHours = false,
  withSecs = false,
) {
  try {
    if (onlyHours) {
      let res =
        ("0" + date.getHours()).slice(-2) +
        ":" +
        ("0" + date.getMinutes()).slice(-2);
      if (withSecs) {
        res += ":" + ("0" + date.getSeconds()).slice(-2);
      }
      return res;
    }
    let res =
      ("0" + date.getDate()).slice(-2) +
      "." +
      ("0" + (date.getMonth() + 1).toString()).slice(-2) +
      "." +
      date.getFullYear();

    if (withHours) {
      res +=
        " " +
        ("0" + date.getHours()).slice(-2) +
        ":" +
        ("0" + date.getMinutes()).slice(-2);
      if (withSecs) {
        res += ":" + ("0" + date.getSeconds()).slice(-2);
      }
    }

    return res;
  } catch {
    return undefined;
  }
}

export function dateToStringWithHours(date) {
  try {
    return (
      ("0" + date.getDate()).slice(-2) +
      "." +
      ("0" + date.getMonth()).slice(-2) +
      "." +
      date.getFullYear() +
      " " +
      ("0" + date.getHours()).slice(-2) +
      ":" +
      ("0" + date.getMinutes()).slice(-2) +
      ":" +
      ("0" + date.getSeconds()).slice(-2)
    );
  } catch {
    return undefined;
  }
}
export const recursiveSearch = (arr, id, param) =>
  (Array.isArray(arr) ? arr : []).reduce((found, n) => {
    return (
      found ??
      ((param ? n[param] : n) === id
        ? n
        : recursiveSearch(n.children, id, param))
    );
  }, null);

export function searchObjectArray(arr, value, key) {
  let result = [];
  if (arr) {
    arr.forEach((obj) => {
      if (obj[key] === value) {
        result.push(obj);
      } else if (obj.children) {
        result = result.concat(searchObjectArray(obj.children, key, value));
      } else if (obj.elements) {
        result = result.concat(searchObjectArray(obj.elements, key, value));
      }
    });
  }

  // console.log(result);
  return result;
}

export const fullHex = (hex, alpha = "") => {
  let r = hex.slice(1, 2);
  let g = hex.slice(2, 3);
  let b = hex.slice(3, 4);

  r = parseInt(r + r, 16);
  g = parseInt(g + g, 16);
  b = parseInt(b + b, 16);

  // return {r, g, b}
  if (alpha) {
    return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
  } else {
    return "rgb(" + r + ", " + g + ", " + b + ")";
  }
};

//convert hex to rgb
export const hex2rgb = (hex, alpha = "") => {
  if (!hex) return undefined;
  if (hex.length === 4) {
    return fullHex(hex, alpha);
  }

  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  if (alpha) {
    return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
  } else {
    return "rgb(" + r + ", " + g + ", " + b + ")";
  }
};

export function formatPhone(string) {
  let re = /\+?\(?\)?\s?-?/gi;
  let result = string.replace(re, "");
  return result;
}

export async function removeBG(string) {
  const promise = new Promise((resolve, reject) => {
    test(string, resolve, reject);
  });
  let res = "";
  await promise.then((result) => {
    res = result;
  });
  if (res) return res;
}

function test(imageURL, resolve, reject) {
  const image = new Image();
  image.src = imageURL;

  // if (!image) return "";
  // let ind = index;

  // image.index = index;
  // console.log(image.src);
  image.onload = function ({ target }) {
    const w = Math.round(target.naturalWidth);
    const h = Math.round(target.naturalHeight);
    const canvas = document.createElement("canvas");
    canvas.width = w;
    canvas.height = h;
    const canvasContext = canvas.getContext("2d");
    canvasContext.drawImage(
      target,
      0,
      0,
      target.width,
      target.height,
      0,
      0,
      w,
      h,
    );
    const canvasImageData = canvasContext.getImageData(0, 0, w, h);
    for (
      let index = 0, dataLength = canvasImageData.data.length;
      index < dataLength;
      index += 4
    ) {
      const r = canvasImageData.data[index];
      const g = canvasImageData.data[index + 1];
      const b = canvasImageData.data[index + 2];
      if ([r, g, b].every((item) => item > 230))
        canvasImageData.data[index + 3] = 0;
    }
    target.width = w;
    target.height = h;
    canvasContext.putImageData(canvasImageData, 0, 0);
    // console.log(canvas.toDataURL());
    resolve(canvas.toDataURL());
    // return target;
  };
  // console.log(x);
  // return image.onload;
}

export function createTextComment(
  name,
  usedPhone,
  usedCar,
  departmentName,
  platform,
  comment,
) {
  return (
    "" +
    (name ? "ФИО: " + name : "") +
    (usedPhone ? "\nТелефон: " + usedPhone : "") +
    (usedCar
      ? "\nАвтомобиль: " +
        (usedCar?.car?.mark.name
          ? usedCar?.car?.mark.name + " "
          : "" + usedCar?.car?.model?.name
            ? usedCar?.car?.model?.name + " "
            : "" + usedCar?.regNum
              ? usedCar?.regNum
              : "")
      : "") +
    (departmentName ? "\nПодразделение: " + departmentName : "") +
    (platform ? "\nУстройство: " + platform : "") +
    (comment ? "\nКомментарий: " + comment : "")
  );
}

export function createDealVAriables(
  usedCar,
  comment,
  companyUuid,
  departmentID,
  platform,
  recIDs,
  servIDs,
  dealDate,
  clientID,
  logined,
  usedPhone,
  name,
) {
  let variables = {
    input: {
      car: {
        id: usedCar?.car?.id,
      },
      comment: comment,
      companyUuid: companyUuid,
      departmentID: departmentID,
      marketing: {
        advChannel: "WebAppApplication",
        sourceID: "App_Request",
        utm: [
          {
            type: "utm_source",
            value: "5Swebapp",
          },
          {
            type: "utm_device",
            value: platform,
          },
        ],
      },
      recommendationID: recIDs,
      serviceID: servIDs,
      startAt: dealDate,
    },
  };
  if (logined) {
    variables = {
      ...variables,
      input: {
        ...variables.input,
        userID: clientID,
      },
    };
  } else {
    let undefUser = {
      name: name,
      phone: formatPhone(usedPhone),
    };
    variables = {
      ...variables,
      input: {
        ...variables.input,
        undefinedUser: undefUser,
      },
    };
  }
  return variables;
}
export function validArray(val, name = "") {
  if (isObjectEmpty(val)) return [];
  try {
    if (!Array.isArray(val)) {
      throw new Error(name + ": is not array! ");
    }
    if (
      typeof val.forEach !== "function" ||
      typeof val.map !== "function" ||
      typeof val.filter !== "function"
    ) {
      throw new Error(name + ": don't have functions! ");
    }
    if (val.length === 0) return [];
    else {
      let first = val[0];
    }

    return val;
  } catch (e) {
    let text =
      getFirstInArray(e?.networkError?.result?.errors)?.message || e.message;
    sessionStorage.setItem(
      "error_" + new Date(Date.now()).toISOString(),
      "validArray." + name + ": " + text,
    );
    consoleBeauty([val], "validArray", "red", "", name);
    return [];
  }
}

export function openFullscreen() {
  var isInFullScreen =
    (document.fullscreenElement && document.fullscreenElement !== null) ||
    (document.webkitFullscreenElement &&
      document.webkitFullscreenElement !== null) ||
    (document.mozFullScreenElement && document.mozFullScreenElement !== null) ||
    (document.msFullscreenElement && document.msFullscreenElement !== null);

  var docElm = document.documentElement;
  if (!isInFullScreen) {
    if (docElm.requestFullscreen) {
      docElm.requestFullscreen();
    } else if (docElm.mozRequestFullScreen) {
      docElm.mozRequestFullScreen();
    } else if (docElm.webkitRequestFullScreen) {
      docElm.webkitRequestFullScreen();
    } else if (docElm.msRequestFullscreen) {
      docElm.msRequestFullscreen();
    }
  } else {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
  }
}

export function createManifest(ref) {
  let manifest = {
    background_color: "#ffffff",
    display: "fullscreen",
    icons: [
      {
        sizes: "512x512 192x192 180x180 120x120 64x64 32x32 24x24 16x16",
        src: ref,
        // type: "image/x-icon",
      },
    ],
    name: "5S Sign",
    short_name: "5S Sign",
    start_url: window.location.origin,
    theme_color: "#000000",
  };
  let stringManifest = JSON.stringify(manifest);
  let blob = new Blob([stringManifest], { type: "application/json" });
  let manifestURL = URL.createObjectURL(blob);
  document
    .querySelector("#site-manifest-placeholder")
    .setAttribute("href", manifestURL);
}

export async function putCacheFunc(
  key,
  value,
  putCacheMutation,
  workspace = "5s_markcode",
) {
  let strVal = saveStringify(value);
  if (!key || !strVal) {
    return;
  }
  await putCacheMutation({
    variables: {
      input: {
        key: key,
        value: strVal,
        workspace: workspace,
      },
    },
  });
}
export const getDateMinusTime = (mounth = 0, days = 0, minutes = 0) => {
  var someDate = new Date(); // add arguments as needed
  if (mounth > 0) someDate.setMonth(someDate.getMonth() - mounth);
  if (days > 0) someDate.setDate(someDate.getDate() - days);
  if (minutes > 0) someDate.setMinutes(someDate.getMinutes() - minutes);

  return someDate;
};

export function deleteBrackets(input) {
  if (!input) return "";
  let regex = /[{()}]/g;

  return input.replace(regex, "");
}

export function mergeRecursive(obj1, obj2) {
  if (Array.isArray(obj2)) {
    return obj1.concat(obj2);
  }
  if (!obj1) {
    obj1 = {};
    if (obj2) return obj2;
  }
  if (!obj2) {
    obj2 = {};
    if (obj1) return obj1;
  }
  for (var p in obj2) {
    try {
      // Property in destination object set; update its value.
      if (obj2[p].constructor === Object) {
        obj1[p] = mergeRecursive(obj1[p], obj2[p]);
      } else if (Array.isArray(obj2[p])) {
        obj1[p] = obj1[p].concat(obj2[p]);
      } else {
        obj1[p] = obj2[p];
      }
    } catch (e) {
      // Property in destination object not set; create it and set its value.
      obj1[p] = obj2[p];
    }
  }
  return obj1;
}

export function getCarName(
  obj,
  array = [],
  any = "Неизвестный автомобиль",
  withoutMark = false,
) {
  if (isObjectEmpty(obj)) return "";

  if (Object.prototype.toString.call(obj) === "[object String]" && array) {
    array.forEach((el) => {
      if (el?.car?.id === obj) {
        obj = el;
      }
    });
  }

  if (Object.prototype.toString.call(obj) === "[object Object]") {
    let marka = obj?.car?.marka?.name || "";
    // let synonyms = !isObjectEmpty(obj?.car?.model?.synonyms);
    let model = deleteBrackets(obj?.car?.model?.name);
    if (withoutMark) {
      if (model) return model;
    } else {
      if (marka || model) {
        if (marka && model) return marka + " " + model;
        else return marka + model;
      }
    }

    let vin = obj?.car?.vin;
    if (vin) return vin;

    let plate = obj?.regNum;
    if (plate) return plate;
  }

  return any;
}

export const isOrderStatusActive = (str) => {
  switch (str) {
    case "CANCELED":
      return false;
    case "COMPLETED":
      return false;
    case "IN_WORK":
      return true;
    case "READY":
      return true;
    default:
      return false;
  }
};

export const translateOrderStatus = (str, type = "") => {
  switch (str) {
    case "CANCELED":
      return constants.ruCANCELED;
    case "COMPLETED":
      return constants.ruCOMPLETED;
    case "IN_WORK":
      return constants.ruIN_WORK;
    case "NONE":
      return "";
    case "ON_WAY":
      return constants.ruTypeInWay;
    case "PAID":
      return constants.ruPAID;
    case "PAY_WAITING":
      return constants.ruPAY_WAITING;
    case "READY":
      return constants.ruREADY;
    case "УДАЛЕН":
      return constants.ruDELETED;
    default:
      return "";
  }
};
export const translateOrderType = (str) => {
  switch (str) {
    case "ЗАКАЗ_НАРЯД":
      return constants.ruTypeZN;

    case "ЗАКАЗ_ПОКУПАТЕЛЯ":
      return constants.ruTypeZP;
    case "ЗАЯВКА_НА_РЕМОНТ":
      return constants.ruTypeZR;
    case "ИНВЕНТАРИЗАЦИЯ":
      return constants.ruTypeINV;

    case "ЛИД":
      return constants.ruTypeLID;
    case ("ПЕРЕМЕЩЕНИЕ_В_ПРОИЗВОДСТВО", "ПЕРЕМЕЩЕНИЕ_ТОВАРОВ_В_ПРОИЗВОДСТВО"):
      return constants.ruTypeManu;
    case "ПЕРЕМЕЩЕНИЕ_В_ФИЛИАЛ":
      return constants.ruTypeMovementIn;
    case "ПЕРЕМЕЩЕНИЕ_ИЗ_ФИЛИАЛА":
      return constants.ruTypeMovementFrom;
    case "ПОСТУПЛЕНИЕ_ТОВАРОВ":
      return constants.ruTypeWAY;

    case "ПРОЧЕЕ":
      return constants.ruOther;
    case "РЕАЛИЗАЦИЯ_ТОВАРОВ":
      return constants.ruTypeR;

    case "СДЕЛКА":
      return constants.ruTypeBP;
    case "ТОВАРЫ_В_ПУТИ":
      return constants.ruTypeInWay;
    default:
      return "";
  }
};

export const getUserName = (user) => {
  if (!user) return "";

  let name = "";
  // let lastName = user?.lastName;
  // if (lastName) name = lastName;
  let firstName = user?.firstName;
  if (firstName) name = (name ? name + " " : "") + firstName;
  let middleName = user?.middleName;
  if (middleName) name = (name ? name + " " : "") + middleName;

  return name;
};

export const toFirstLetterUpperCase = (str) => {
  if (!str) return "";
  str = str.trim();
  if (!str) return "";
  return (
    str.charAt(0).toUpperCase() +
    str.slice(1).toLowerCase().replaceAll("_", " ")
  );
};

export const isToken = (str) => {
  let reg = new RegExp("(^.{36}$)|(^.{36}):(.+)");
  let res = reg.exec(str, "g");
  if (!res) return false;
  return true;
};
export const isActiveChannel = (channels, name) => {
  const find = (channels ?? []).find((el) => {
    if (el?.name === name) return true;
    else return false;
  });
  return find?.active || false;
};

export function findInArray(array, value, param = "") {
  if (isObjectEmpty(array)) return null;
  return array.find((element) => {
    if (
      (param ? element[param] : element) === value ||
      isIdentical(param ? element[param] : element, value)
    )
      return true;
    return false;
  });
}

export async function searchOrders(findParams, companyUuid, getOrdersQuery) {
  let { data } = await getOrdersQuery({
    variables: {
      code: findParams?.code,
      companyUuid: companyUuid,
      orderNumber: findParams?.orderNumber,
      regNum: findParams?.plate,
    },
  });
  if (!isObjectEmpty(data?.export_ordersSearch)) {
    if (Array.isArray(data?.export_ordersSearch)) {
      return data?.export_ordersSearch;
    }
  }
  return [];
}

export async function getOrdersByToken(
  token,
  companyUuid,
  ordersListQuery,
  { dataObj, forceSetDataObj },
) {
  if (!token || !companyUuid) return [];
  let { data } = await ordersListQuery({
    variables: {
      adminToken: token,
      companyUuid: companyUuid,
    },
  });
  if (!isObjectEmpty(data?.export_ordersList)) {
    if (Array.isArray(data?.export_ordersList)) {
      let arr = [];
      data?.export_ordersList.forEach((element) => {
        if (
          translateOrderStatus(element?.payStatus) === constants.ruPAY_WAITING
        ) {
          arr = [...arr, element];
        }
      });

      arr = arr.sort((a, b) => {
        let dateA = new Date(a.docDate || 0);
        let dateB = new Date(b.docDate || 0);
        if (dateA < dateB) return 1;
        else return -1;
      });

      if (!isIdentical(dataObj?.searchDocs, arr))
        forceSetDataObj(arr, "searchDocs");
      return arr;
    }
  }
  return [];
}

export function sortDocByDate(arr, decr = false) {
  return arr.sort((a, b) => {
    let dateA = new Date(a?.general_params?.date || 0);
    let dateB = new Date(b?.general_params?.date || 0);
    if (dateA < dateB) return decr ? 1 : -1;
    else return decr ? -1 : 1;
  });
}

export function isChild(doc, arr) {
  let parentId = doc?.general_params?.parent_doc?.id || "";
  if (!parentId) return false;
  let find = arr.find((e) => e?.id === parentId);
  if (find) return true;
  return false;
}

export function sortDocListByParent(arr) {
  let sorted = [];
  try {
    let dataSorted = sortDocByDate([...(arr || [])]);
    dataSorted.forEach((doc, index) => {
      let parentId = doc?.general_params?.parent_doc?.id || "";
      if (!parentId && !findInArray(sorted, doc)) {
        sorted = [...sorted, doc];
      } else {
        let find = dataSorted.find((e) => e?.id === parentId);
        if (find) {
          if (!findInArray(sorted, find)) {
            sorted = [...sorted, find];
          }
          let parentIndex = sorted.indexOf(find);
          let index = parentIndex;
          let filtered = [...sorted].filter(
            (e) => e?.general_params?.parent_doc?.id === parentId,
          );
          filtered = sortDocByDate(filtered);
          if (filtered.length !== 0) {
            index = sorted.indexOf(filtered[filtered.length - 1]);
          }
          sorted = [].concat(
            sorted.slice(0, index + 1),
            doc,
            sorted.slice(index + 1),
          );
        } else if (!findInArray(sorted, doc)) {
          sorted = [...sorted, doc];
        }
      }
    });
  } catch (error) {
    console.log(error);
  }

  return sorted;
}
